module.exports = __webpack_public_path__ + "img/payment.af84e6ad.svg";